import { Box } from '@mui/material';
import { SSB_STEPS, StepDefinition } from '../../types/SimilarlySituated/StepDefinition.type';

interface SsbStepperProps {
  activeStep: StepDefinition;
  enabledSteps: StepDefinition[];
  onStepChange: (step: StepDefinition) => void;
}

function SsbStepper({ activeStep, enabledSteps, onStepChange }: SsbStepperProps) {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
      {SSB_STEPS.map((step, index) => {
        const isActive = step === activeStep;
        const isEnabled = enabledSteps.includes(step);

        return (
          <Box
            key={step}
            component='button'
            type='button'
            disabled={!isEnabled}
            onClick={() => onStepChange(step)}
            sx={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '4px',
              border: isActive ? '1px solid #132B50' : '1px solid #A0AEC0',
              backgroundColor: isActive ? '#DBEAFE' : isEnabled ? '#fff' : '#eff1f3',
              borderRadius: '6px',
              padding: '6px 10px',
              fontSize: '12px',
              fontWeight: isActive ? 600 : 500,
              color: isActive ? '#1A365D' : isEnabled ? '#4A5568' : '#A0AEC0',
              cursor: isEnabled ? 'pointer' : 'not-allowed',
              whiteSpace: 'nowrap',
            }}
          >
            {index + 1} · {step}
          </Box>
        );
      })}
    </Box>
  );
}

export default SsbStepper;
